<ng-container *ngIf="accountInfo">
    <dirty-tracking [forms]="[newAccountForm]"></dirty-tracking>
    <form novalidate #newAccountForm="ngForm" [ngClass]="{'was-validated': submitAttempt}">
        <div class="entity-form" malihu-scrollbar [scrollbarOptions]="scrollbarOptions">
            <div class="row align-items-end gx-3">
                <div class="col mb-3">
                    <label for="pdxIdentifier" class="form-label">PDx ID</label>
                    <input type="text" class="form-control form-control-lg" id="pdxIdentifier" placeholder="ID" name="pdxIdentifier" [(ngModel)]="accountInfo.pdxIdentifier" focus-me />
                    <div class="invalid-feedback">
                        <i class="fas fa-exclamation-circle"></i> This field is required.
                    </div>
                </div>
                <div class="col-md-4 mb-3">
                    <label for="editUserStatus" class="form-label">Status</label>
                    <div class="form-check checkbox-slider--b-flat checkbox-slider-md">
                        <label class="m-0">
                            <input type="checkbox" id="editUserStatus" name="editUserStatus" [(ngModel)]="accountInfo.isActive"><span class="user-toggle" [ngClass]="accountInfo.isActive ? 'text-success' : 'text-danger'">{{accountInfo.isActive ? 'Active' : 'Deactivated'}}</span>
                        </label>
                    </div>
                </div>
            </div>
            <div class="row gx-3">
                <div class="col-md mb-3">
                    <label for="entityName" class="form-label">Name<sup class="text-danger">*</sup></label>
                    <input type="text" class="form-control form-control-lg" id="entityName" placeholder="Name" required name="entityName" [(ngModel)]="accountInfo.entityName">
                    <div class="invalid-feedback">
                        <i class="fas fa-exclamation-circle"></i> This field is required.
                    </div>
                </div>
                <div class="col-md mb-3">
                    <label for="entityName2" class="form-label">Name 2</label>
                    <input type="text" class="form-control form-control-lg" id="entityName2" placeholder="Name 2 (optional)" name="entityNamePart2" [(ngModel)]="accountInfo.entityNamePart2">
                </div>
            </div>
            <div class="row gx-3">
                <div class="col-md-8 mb-3">
                    <label for="entityAddress1" class="form-label">Street Address</label>
                    <input type="text" class="form-control form-control-lg" name="addressLine1" [(ngModel)]="accountInfo.addressLine1" id="entityAddress1" placeholder="Address 1">
                </div>
                <div class="col-md-4 mb-4">
                    <label for="entityAddress2" class="form-label">Apt, Suite, Etc.</label>
                    <input type="text" class="form-control form-control-lg" name="addressLine2" [(ngModel)]="accountInfo.addressLine2" id="entityAddress2" placeholder="Address 2">
                </div>
            </div>
            <div class="row gx-3">
                <div class="col-md mb-3">
                    <label for="entityCity" class="form-label">City</label>
                    <input type="text" class="form-control form-control-lg" name="city" [(ngModel)]="accountInfo.city" id="entityCity" placeholder="City">
                </div>
                <div class="col-md mb-3">
                    <label for="entityState" class="form-label">State</label>
                    <select class="form-select form-select-lg" id="entityState" name="state" [(ngModel)]="accountInfo.state">
                        <option [value]="null">State</option>
                        <option *ngFor="let s of stateList" [value]="s.value">{{s.text}}</option>
                    </select>
                </div>
                <div class="col-md mb-3">
                    <label for="entityZip" class="form-label">Zip</label>
                    <input type="text" class="form-control form-control-lg" name="postalCode" [(ngModel)]="accountInfo.postalCode" id="entityZip" placeholder="Zip">
                </div>
            </div>
            <div class="row gx-3">
                <div class="col-md mb-3">
                    <label for="entityPhone" class="form-label">Phone</label>
                    <input type="text" class="form-control form-control-lg" name="phoneNumber" [(ngModel)]="accountInfo.phoneNumber" id="entityPhone" placeholder="Phone">
                </div>
                <div class="col-md mb-3">
                    <label for="entityPhone" class="form-label">Specialty</label>
                    <input type="email" class="form-control form-control-lg" name="specialty" [(ngModel)]="accountInfo.specialty" id="entityGPOId" placeholder="Specialty" [ngbTypeahead]="searchSpecialty">
                </div>
            </div>
            <div class="row gx-3">
                <div class="col-md mb-3">
                    <label for="entityPhone" class="form-label">DEA</label>
                    <input type="text" class="form-control form-control-lg" name="dea" [(ngModel)]="accountInfo.dea" id="entityGPOId" placeholder="DEA">
                </div>
                <div class="col-md mb-3">
                    <label for="entityPhone" class="form-label">HIN</label>
                    <input type="text" class="form-control form-control-lg" name="hin" [(ngModel)]="accountInfo.hin" id="entityGPOName" placeholder="HIN">
                </div>
            </div>
            <div class="row gx-3">
                <div class="col-md mb-3">
                    <label for="entityPhone" class="form-label">Entity Code</label>
                    <input type="text" class="form-control form-control-lg" name="entityCode" [(ngModel)]="accountInfo.entityCode" id="entityGPOId" placeholder="Entity Code">
                </div>
                <div class="col-md mb-3">
                    <label for="entityPhone" class="form-label">Site Code</label>
                    <input type="text" class="form-control form-control-lg" name="siteCode" [(ngModel)]="accountInfo.siteCode" id="entityGPOName" placeholder="Site Code">
                </div>
            </div>
            <div class="row gx-3">
                <div class="col-md mb-3">
                    <label for="entityGPO" class="form-label">BCC Order Email Address</label>
                    <input type="text" class="form-control form-control-lg" name="bccEmailAddress" [(ngModel)]="accountInfo.bccEmailAddress" id="bccEmailAddress" placeholder="Email Address">
                </div>
            </div>
            <div class="row gx-3">
                <div class="col-md-4 mb-3">
                    <label for="isBilling" class="form-label">Is Billing</label>
                    <div class="form-check checkbox-slider--b-flat checkbox-slider-md">
                        <label class="m-0">
                            <input type="checkbox" id="isBilling" name="isBilling" [(ngModel)]="accountInfo.isBilling"><span class="user-toggle">{{accountInfo.isBilling ? 'Yes' : 'No'}}</span>
                        </label>
                    </div>
                </div>
            </div>
            <hr />
            <h5 class="text-primary text-strong mb-3">Primary Contact</h5>
            <div class="row gx-3">
                <div class="col-md mb-3">
                    <input type="text" class="form-control form-control-lg" name="primaryContactFirstName" [(ngModel)]="accountInfo.primaryContactFirstName" id="entityGPOId" placeholder="First Name">
                </div>
                <div class="col-md mb-3">
                    <input type="text" class="form-control form-control-lg" name="primaryContactLastName" [(ngModel)]="accountInfo.primaryContactLastName" id="entityGPOName" placeholder="Last Name">
                </div>
            </div>
            <div class="row gx-3">
                <div class="col-md mb-3">
                    <input type="email" class="form-control form-control-lg" name="primaryContactEmail" [(ngModel)]="accountInfo.primaryContactEmail" id="entityGPOId" placeholder="Email Address">
                </div>
            </div>
            <hr />
            <label for="entityGPO" class="form-label">Primary GPO</label>
            <div class="row gx-3">
                <div class="col-md-3 mb-3">
                    <input type="text" class="form-control form-control-lg" name="primaryGPOID" [(ngModel)]="accountInfo.primaryGPOID" id="entityGPOId" placeholder="ID">
                </div>
                <div class="col-md mb-3">
                    <input type="text" class="form-control form-control-lg" name="primaryGPO" [(ngModel)]="accountInfo.primaryGPO" id="entityGPOName" placeholder="Name">
                </div>
            </div>
            <label for="entityGPO" class="form-label">Secondary GPO</label>
            <div class="row gx-3">
                <div class="col-md-3 mb-3">
                    <input type="text" class="form-control form-control-lg" name="secondaryGPOID" [(ngModel)]="accountInfo.secondaryGPOID" id="entityGPOId" placeholder="ID">
                </div>
                <div class="col-md mb-3">
                    <input type="text" class="form-control form-control-lg" name="secondaryGPO" [(ngModel)]="accountInfo.secondaryGPO" id="entityGPOName" placeholder="Name">
                </div>
            </div>
        </div>
        <div class="entity-card-actions d-flex align-items-center" [ngClass]="accountInfo.entityId ? 'justify-content-between' : 'justify-content-end'">
            <button type="button" (click)="deleteEntity()" class="btn btn-outline-danger btn-round btn-lg" *ngIf="accountInfo.entityId"><i class="far fa-trash-alt"></i> Delete</button>
            <div>
                <button type="button" (click)="cancel()" class="btn btn-outline-black btn-round btn-lg me-2"><i class="far fa-times"></i> Cancel</button>
                <button type="submit" class="btn btn-secondary btn-round btn-lg" (click)="saveAccount()"><i class="far fa-check"></i>
                    Save</button>
            </div>
        </div>
    </form>
</ng-container>